import { render, staticRenderFns } from "./SelectableDeck.vue?vue&type=template&id=23e54c74&scoped=true&"
import script from "./SelectableDeck.vue?vue&type=script&lang=js&"
export * from "./SelectableDeck.vue?vue&type=script&lang=js&"
import style0 from "./SelectableDeck.vue?vue&type=style&index=0&id=23e54c74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e54c74",
  null
  
)

export default component.exports